import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";
import { useI18n } from "@/lib/i18n";
import { GoldButton } from "@/components/Brand";

const SIZES = ["2x2", "4x6", "5x7", "8x10", "11x14", "20x30"];

export default function AdminPrintPrices() {
  const { t } = useI18n();
  const [state, setState] = useState({ enabled: false, mode: "from", prices: {} });
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get("/admin/print-prices").then((r) => setState(r.data)).catch(() => {});
  }, []);

  const save = async () => {
    setBusy(true);
    try {
      const { data } = await api.put("/admin/print-prices", state);
      setState(data);
      toast.success(t("admin.siteSaved"));
    } catch (err) {
      toast.error(apiError(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <section className="mt-10 border border-[#C69A3B]/40 bg-white p-6" data-testid="admin-print-prices">
      <p className="label-mono">{t("admin.printPrices")}</p>
      <p className="mt-2 text-xs text-[#5A5752]">{t("admin.printPricesHelp")}</p>

      <label className="mt-5 flex items-center gap-2 text-sm text-[#252525]">
        <input
          type="checkbox"
          data-testid="print-prices-enabled"
          checked={state.enabled}
          onChange={(e) => setState((s) => ({ ...s, enabled: e.target.checked }))}
        />
        {t("admin.printPricesShow")}
      </label>

      <div className="mt-4 flex gap-2">
        {[["from", "admin.printPricesFrom"], ["exact", "admin.printPricesExact"]].map(([key, label]) => (
          <button
            key={key}
            type="button"
            data-testid={`print-prices-mode-${key}`}
            onClick={() => setState((s) => ({ ...s, mode: key }))}
            className={`min-h-[38px] border px-4 text-[11px] ${
              state.mode === key ? "border-[#8F3329] bg-[#8F3329] text-[#FAFAF7]" : "border-[#C69A3B] text-[#8F3329]"
            }`}
          >
            {t(label)}
          </button>
        ))}
      </div>

      <div className="mt-5 grid gap-4 sm:grid-cols-3 lg:grid-cols-6">
        {SIZES.map((size) => (
          <label key={size} className="block">
            <span className="label-mono">{size}</span>
            <input
              type="number"
              step="0.01"
              min="0"
              placeholder="0.00"
              data-testid={`print-price-${size}`}
              value={state.prices?.[size] ?? ""}
              onChange={(e) =>
                setState((s) => ({ ...s, prices: { ...s.prices, [size]: e.target.value } }))
              }
              className="mt-1 min-h-[42px] w-full border border-[#C69A3B]/60 bg-white px-3 text-sm"
            />
          </label>
        ))}
      </div>

      <GoldButton className="mt-6" data-testid="print-prices-save" disabled={busy} onClick={save}>
        {t("btn.save")}
      </GoldButton>
    </section>
  );
}
